import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { updateCategory } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { ...rest } = values;
  return {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useUpdateCategory() {
  return useMutation({
    mutationFn: async ({ item, categoryId }) => {
      const payload = buildPayload(item);
      const response = await updateCategory({ item: payload, categoryId });
      return response;
    },
    onSuccess: () => {
      toast.success("Category Updated Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
